import {Title} from '@services/resource/title';

export interface StammdatenResource {
  name: string;
  nickname: string;
  street: string;
  zipCode: string;
  city: string;
  companyPhoneCountryCode: string;
  companyPhone: string;
  countryISOCode: string;
  gln: string | null;
  title: Title;
  lastName: string;
  firstName: string;
  email: string;
  contactPersonPhoneCountryCode: string;
  contactPersonPhone: string;
}

export const defaultStammdatenResource: StammdatenResource = {
  name: '',
  nickname: '',
  street: '',
  zipCode: '',
  city: '',
  companyPhoneCountryCode: '49',
  companyPhone: '',
  countryISOCode: 'DE',
  gln: null,
  title: Title.FEMALE,
  lastName: '',
  firstName: '',
  email: '',
  contactPersonPhoneCountryCode: '49',
  contactPersonPhone: '',
};
